/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append || '';
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);

      if (!this.terms_checkbox) return;

      const root =
        this.closest('cart-drawer') ||
        this.closest('.thb-cart-collaterals') ||
        this.closest('.side-panel') ||
        document;

      this.gateWraps = root.querySelectorAll('[data-terms-gate-wrap], .terms-gate-wrap');
      this.gateOverlays = root.querySelectorAll('[data-terms-gate-overlay]');

      const showErrorState = () => {
        this.classList.remove('has-error', 'blink-error');
        void this.offsetWidth;
        this.classList.add('has-error', 'blink-error');
        this.terms_checkbox.focus();
      };

      const clearErrorState = () => {
        this.classList.remove('has-error', 'blink-error');
      };

      const updateGateState = () => {
        if (!this.gateWraps.length) return;

        this.gateWraps.forEach((gateWrap) => {
          if (this.terms_checkbox.checked) {
            gateWrap.classList.remove('is-locked');
            gateWrap.classList.add('is-unlocked');
          } else {
            gateWrap.classList.remove('is-unlocked');
            gateWrap.classList.add('is-locked');
          }
        });

        if (this.terms_checkbox.checked) {
          clearErrorState();
        }
      };

      this.gateOverlays.forEach((overlay) => {
        overlay.addEventListener('click', (e) => {
          if (this.terms_checkbox.checked) return;

          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }

          showErrorState();
          updateGateState();
          return false;
        }, true);
      });

      this.terms_checkbox.addEventListener('change', () => {
        updateGateState();
      });

      updateGateState();
    }
  }

  customElements.define('terms-checkbox', TermsCheckbox);
}